import PageLayout from "@/components/PageLayout"

const CheckoutCancel = () => {
  return <PageLayout title="Checkout Cancel"></PageLayout>
}

export default CheckoutCancel
